import { render } from "./AllowenceType.vue?vue&type=template&id=09428249"
import script from "./AllowenceType.vue?vue&type=script&lang=js"
export * from "./AllowenceType.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./AllowenceType.vue?vue&type=style&index=0&id=09428249&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__